import { render } from "./ComparacionImagen.vue?vue&type=template&id=2457d414&scoped=true"
import script from "./ComparacionImagen.vue?vue&type=script&lang=js"
export * from "./ComparacionImagen.vue?vue&type=script&lang=js"

import "./ComparacionImagen.vue?vue&type=style&index=0&id=2457d414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2457d414"]])

export default __exports__